import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import { ToggleEntry } from './ToggleEntry.js';
import { LogProvider } from '../Providers/LogProvider.js';
import style from './LevelSettings.css';
import { LogUploader } from "./LogUploader";
import React from "react";
export var Settings =
/*#__PURE__*/
function (_Component) {
  _inherits(Settings, _Component);

  function Settings() {
    _classCallCheck(this, Settings);

    return _possibleConstructorReturn(this, _getPrototypeOf(Settings).apply(this, arguments));
  }

  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("div", {
        className: style.settings + ' popovermenu bubble open menu'
      }, React.createElement("h4", null, t('settings', 'Log levels')), LogProvider.levels.map(function (name, level) {
        return React.createElement(ToggleEntry, {
          key: level,
          active: _this.props.levels[level],
          onChange: _this.props.setLevel.bind(_this, level)
        }, name);
      }), React.createElement("h4", null, t('settings', 'Log content')), React.createElement(ToggleEntry, {
        active: this.props.live,
        onChange: this.props.setLive
      }, t('settings', 'Live update')), React.createElement(LogUploader, {
        onLogFile: this.props.onLogFile
      }), React.createElement("a", {
        href: OC.generateUrl('settings/admin/log/download'),
        className: "button"
      }, t('settings', 'Download logs')));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Settings;
}(Component);
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Settings, "Settings", "/srv/http/owncloud/apps/logreader/js/Components/Settings.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();